module.exports = __webpack_public_path__ + "background-triangles.f5a687201c40c6d0f2775a771c9401c4.png";